module.exports = __webpack_public_path__ + "assets/icon_dashboard.9ed4cf4c.svg";